<template>
  <v-container fluid class="px-0">
    <h2 class="font-weight-thin">Stay in Touch</h2>
    <p class="ctaText">
      Sign up for our newsletter to get happyly events in your inbox
    </p>
    <v-btn class="primary" :href="href" target="_blank">Subscribe</v-btn>
  </v-container>
</template>

<script>
export default {
  name: 'NewsletterSignupCTA',
  data: () => ({
    href: 'https://share.hsforms.com/1WngpZFDuTUqCh3sWNGK-pw426o5',
  }),
}
</script>

<style scoped>
.ctaText {
  font-size: 14px;
}
</style>
